import { render, staticRenderFns } from "./CreateRecord.vue?vue&type=template&id=f966699a&scoped=true&"
import script from "./CreateRecord.vue?vue&type=script&lang=js&"
export * from "./CreateRecord.vue?vue&type=script&lang=js&"
import style0 from "./CreateRecord.vue?vue&type=style&index=0&id=f966699a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f966699a",
  null
  
)

export default component.exports